var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('invoice-list',{ref:"invoiceList",attrs:{"cate":_vm.cate}})}
var staticRenderFns = []

export { render, staticRenderFns }